<template>
  <div class="auth-shell">
    <header class="auth-head">
      <AppBrand />
    </header>

    <main class="error-main">
      <div class="error-code mono">
        <b>{{ statusCode }}</b>
        <span />
      </div>
      <h1 class="display">{{ notFound ? 'Nothing at this address.' : 'Something went wrong.' }}</h1>
      <p v-if="notFound">The link may be old, or the email may have been deleted.</p>
      <p v-else>{{ error?.statusMessage || error?.message || 'The page could not be loaded.' }}</p>
      <div class="flex flex-wrap gap-3">
        <button type="button" class="btn btn-primary btn-lg" @click="clearError({ redirect: '/app/emails' })">Go to emails</button>
        <button type="button" class="btn btn-lg" @click="clearError({ redirect: '/app/dashboard' })">Go to the dashboard</button>
      </div>
    </main>
  </div>
</template>

<script lang="ts" setup>
const error = useError()

const statusCode = computed(() => Number(error.value?.statusCode) || 500)
const notFound = computed(() => statusCode.value === 404)
</script>

<style scoped>
.error-main {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  gap: 22px;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px 24px 96px;
}

.error-code {
  display: flex;
  align-items: center;
  gap: 12px;
  color: var(--muted);
}

/* The slicer's cut line, as the page's one flourish. */
.error-code span {
  flex: 0 1 320px;
  border-top: 2px solid var(--cut);
}

h1 {
  margin: 0;
  font-size: clamp(48px, 8vw, 112px);
  font-weight: 700;
  letter-spacing: -0.04em;
  line-height: 0.92;
}

p {
  max-width: 520px;
  margin: 0;
  color: var(--muted);
}
</style>
